import { Filial } from "../filial/filial";

export class RelatorioDTO {

    filial: Filial | null = null;

    dataInicial: Date | null = null;

    dataFinal: Date | null = null;

    idsNumberArray: number[] | null = null;

    idsMedicosArray: number[] | null = null;

    idsStringArray: string[] | null = null;

    codTipoAgrupamento: string | null = null;

    idPaciente: number | null = null;

    idPlanoSaude: number | null = null;

    idProcedimento: number | null = null;

    constructor() {
    }
}
